import React, { useState, useEffect } from 'react';
import dynamic from 'next/dynamic'
import PageLoader from '../components/PopupForm/Loading';
const Navbar = dynamic(() => import('../components/Layouts/Navbar', { ssr: false }));
const Footer = dynamic(() => import('../components/Layouts/Footer', { ssr: false }));
const Breadcrumb = dynamic(() => import('../components/Layouts/Breadcrumb', { ssr: false }));
const PropositionSlider = dynamic(() => import('../components/MarketResearch/PropositionSlider', { ssr: false }));
const AllReportsTabs = dynamic(() => import('../components/MarketResearch/AllReportsTabs', { ssr: false }));
// import Projects from '../components/About/Projects';
const LatestReports = dynamic(() => import('../components/MarketResearch/LatestReports', { ssr: false }));
const HeroBanner = dynamic(() => import('../components/Common/HeroBanner', { ssr: false }));
const Image = dynamic(() => import('next/image', { ssr: false }));
const KeyFacts = dynamic(() => import('../components/MarketResearch/KeyFacts', { ssr: false }));
const LicenseTypes = dynamic(() => import('../components/MarketResearch/LicenseTypes', { ssr: false }));
const Head = dynamic(() => import('next/head', { ssr: false }));

import axios from 'axios';


const MarketResearch = () => {

    return (
        <>
            {/* <PageLoader /> */}
            
            <Navbar />
            <HeroBanner background={process.env.IMG_CDN + "img/market-research/Market-Research.webp"}
                title={<>Our Insights, Your Future</>}
                description={<>Pharma and Healthcare Market Analysis Reports
                    <br />
                    <br />
                    <ul>
                        <li className='mb-2'>
                            <div className="flex">
                                <Image priority={false} alt="icon1" className="pr-6" src={process.env.IMG_CDN + 'img/market-research/svg/deep_expertise.svg'} width={60} height={60} />
                                <div className='mt-1'>Deep expertise in healthcare</div>
                            </div>
                        </li>
                        <li className='mb-2'>
                            <div className="flex">
                                <Image priority={false} alt="icon2" className="pr-6" src={process.env.IMG_CDN + 'img/market-research/svg/project.svg'} width={60} height={60} />
                                <div className='mt-1'>Tailored approach to each project</div>
                            </div>
                        </li>
                        <li className='mb-2'>
                            <div className="flex">
                                <Image priority={false} alt="icon3" className="pr-6" src={process.env.IMG_CDN + 'img/market-research/svg/human_analysis.svg'} width={60} height={60} />
                                <div className='mt-1'>Utilization of Human analysis & AI</div>
                            </div>
                        </li>
                        <li className='mb-2'>
                            <div className="flex">
                                <Image priority={false} alt="icon4" className="pr-6" src={process.env.IMG_CDN + 'img/market-research/svg/report_models.svg'} width={60} height={60} />
                                <div className='mt-1'>Excel-based interactive models</div>
                            </div>
                        </li>
                    </ul>
                </>}
            />
            <Breadcrumb />
            <PropositionSlider title="Unique Selling Propositions" shortDescription="DelveInsight has a vast repository of over 7,000 research reports in the healthcare sectors, including pharma and biotech, across a spectrum of 27 therapeutic areas spanning 20+ geographies." />
            <AllReportsTabs title="All Reports" />
            <KeyFacts title="Key Facts" />
            <LatestReports title="Latest Reports" shortDescription="Our latest reports are synthesized from a wide variety of sources to keep our clients up-to-date with the recent trends of the Life Science industry." />
            <LicenseTypes title="REPORT LICENSE TYPES" shortDescription="DelveInsight offers different types of licensing solutions to fulfil the diverse demands of organizations and suit their purchasing capability." />
            <Footer />
        </>
    )
}

MarketResearch.getInitialProps = async (NextPageContext) => {
    const slugData = NextPageContext.pathname
    try {
        const response = await axios.get(process.env.API_URL + '/meta' + slugData);
        return {
            title: (response?.data.meta_title) ? response?.data.meta_title : "Cart | DelveInsight",
            description: (response?.data.meta_description) ? response?.data.meta_description : "DelveInsight is a pioneer in Healthcare Market Research Reports & Consulting Services. We advise Pharma leaders on making strategic decisions across all therapy areas & geographies.",
            keywords: (response?.data.meta_keywords) ? response?.data.meta_keywords : "pharmaceutical business consulting, market research company, pharma consulting, biotech consulting, pharma market research, pharma market insights, biotech consulting,  pharma consulting service, pharma leading, market trends.",
        }
    } catch (error) {
        console.error('Error fetching data:', error.message);
        return {
            title: "Cart | DelveInsight",
            description: "DelveInsight is a pioneer in Healthcare Market Research Reports & Consulting Services. We advise Pharma leaders on making strategic decisions across all therapy areas & geographies.",
            keywords: "pharmaceutical business consulting, market research company, pharma consulting, biotech consulting, pharma market research, pharma market insights, biotech consulting,  pharma consulting service, pharma leading, market trends.",
        };
    }
}

export default MarketResearch;


